import { useMemo } from "react";
import { Breadcrumbs, ClickAwayListener, Grow, Link, MenuItem, MenuList, Paper, Popper, Stack, Typography } from "@mui/material";
import { GenerateColumnsDefinition } from "./table_column";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import { usePermissaoAcessoCadastroViewModel } from "../../viewModels/permissao_acesso_cadastro_view_model";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { BackButton } from "../../../../../common/components/back_button";
import { PermissaoAcessoGrupoLista } from "../../../domain/models/permissao_acesso_grupo_lista";
import { DefaultAutocomplete } from "../../../../../common/components/default_autocomplete";
import { StyledDataGridTreePermissoes } from "./components/styled_data_grid_tree_permissoes";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ReportLogAcessoSistemaModal } from "./components/report_log_acesso_sistema_modal";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

/**
 * GrupoAcessoLista
 */

export const PermissaoAcessoCadastro = () => {
  const viewModel = usePermissaoAcessoCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateColumnsDefinition({
      onDesabilitarCriacaoChange: viewModel.handleDesabilitarCriacaoChange,
      onDesabilitarExclusaoChange: viewModel.handleDesabilitarExclusaoChange,
      onDesabilitarEdicaoChange: viewModel.handleDesabilitarEdicaoChange,
      onDesabilitarRelatorioChange: viewModel.handleDesabilitarRelatorioChange,
      onDesabilitarAlteracaoStatusChange: viewModel.handleDesabilitarAlteracaoStatusChange,
      onDesabilitarExclusaoDocChange: viewModel.handleDesabilitarExclusaoDocChange,
      onDesabilitarExclusaoLoteChange: viewModel.handleDesabilitarExclusaoLoteChange,
      onDesabilitarAprovacaoLoteChange: viewModel.handleDesabilitarAprovacaoLoteChange,
    });
  }, [
    viewModel.handleDesabilitarCriacaoChange,
    viewModel.handleDesabilitarExclusaoChange,
    viewModel.handleDesabilitarEdicaoChange,
    viewModel.handleDesabilitarRelatorioChange,
    viewModel.handleDesabilitarAlteracaoStatusChange,
    viewModel.handleDesabilitarExclusaoDocChange,
    viewModel.handleDesabilitarExclusaoLoteChange,
    viewModel.handleDesabilitarAprovacaoLoteChange,

  ]);

  return (

    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row w-full justify-end gap-2">
              <BackButton onClick={() => viewModel.handlePageBack()} />
              <div>
                <Stack direction="row" spacing={2}>

                  <div className="w-[12rem]">
                    <PrimaryButton
                      ref={viewModel.menuRef}
                      id="composition-button"
                      aria-controls={viewModel.openMenu ? "composition-menu" : undefined}
                      aria-expanded={viewModel.openMenu ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={viewModel.handleToggleMenu}
                      buttonColor="primary-green"
                    >
                      Opções
                    </PrimaryButton>
                    <Popper
                      style={{ zIndex: 10000 }}
                      open={viewModel.openMenu}
                      anchorEl={viewModel.menuRef.current}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom-start" ? "left top" : "left bottom"
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={viewModel.handleCloseMenu}>
                              <MenuList
                                autoFocusItem={viewModel.openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={viewModel.handleListKeyDown}
                              >
                                <MenuItem onClick={() => viewModel.handleOpenReportLogAcessoSistemaModal(true)}>Histórico de Acesso</MenuItem>
                                <MenuItem onClick={() => viewModel.handlePermissaoAcessoExportar()}>Permissões de Acesso</MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>
            </div>
          }
        />
      </PageTopBar>


      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit" >
            Administração
          </Link>
          <Typography className="text-primary-green">
            Permissão de Acesso
          </Typography>
        </Breadcrumbs>


        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <div className="flex flex-col w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                  <div className="w-[40%] flex flex-col  justify-start items-start pr-4 mb-4 ">
                    {viewModel.selectedIdGrupoAcesso === undefined ? (
                      <span className="text-lg font-semibold text-red-500 mb-2">
                        Selecione o grupo para alterar as permissões!!
                      </span>
                    ) : <></>}

                    <DefaultAutocomplete
                      readOnly={false}
                      label='Grupos de Acesso'
                      options={viewModel.ddlGrupoAcesso}
                      value={viewModel.ddlGrupoAcesso.find(x => x.id === viewModel.selectedIdGrupoAcesso) ?? null}
                      getOptionLabel={x => x.title}
                      getOptionKey={x => x.id}
                      onChange={v => viewModel.handleGrupoAcessoChange(v?.id ?? null)}

                    />
                  </div>
                  <div className="w-full ">
                    <label className="font-semibold mb-3">Telas do Sistema:</label>
                    <Stack spacing={0}>
                      <StyledDataGridTreePermissoes
                        apiRef={viewModel.apiRef}
                        tableName="permissao_acesso_grupo_lista"
                        disableColumnMenu={false}
                        showToolbar={true}
                        disableRowSelectionOnClick={true}
                        getRowId={(row: PermissaoAcessoGrupoLista) => row.id}
                        columns={columnsDefinition}
                        collapsed={true}
                        loading={false}
                        checkboxSelection={true}
                        rows={viewModel.permissaoAcessoGrupoLista}
                        rowCount={viewModel.permissaoAcessoGrupoLista.length}
                        pageSizeOptions={[10, 25, 50, 100]}
                        paginationMode="server"
                        paginationModel={{
                          page: 1,
                          pageSize: 250,
                        }}
                        pinnedColumns={{
                          left: ["__check__"],
                        }}

                        //tree data
                        treeData
                        maxWidth="80rem"
                        getTreeDataPath={(row) => row.path}
                        getRowClassName={(params) => {
                          // Verifica se é linha pai (nível 1 da hierarquia)
                          return params.row.path?.length === 1 ? 'parent-row' : '';
                        }}
                        groupingColDef={{
                          headerName: "Modulos/Telas",
                          hideDescendantCount: true,
                          flex: 1,
                        }}

                        sx={{
                          '& .parent-row': {
                            backgroundColor: '#f5f5f5',
                            '&:hover': {
                              backgroundColor: '#eeeeee',
                            },
                          },
                          '& .parent-row.Mui-selected': {
                            backgroundColor: '#e0e0e0',
                            '&:hover': {
                              backgroundColor: '#d5d5d5',
                            },
                          },
                          '& .MuiDataGrid-treeDataGroupingCell': {
                            paddingLeft: '48px !important',
                          },
                        }}

                      />
                    </Stack>
                  </div>
                </div>



              </>
            )
        }
      </div>

      <BottomBar>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
            <h1
              className="text-sm text-black dark:text-white"
              onClick={viewModel.handlePageBack}>
              Cancelar
            </h1>
          </div>
          <div className="w-40">
            {viewModel.saving ? (
              <PrimaryButton>Salvando...</PrimaryButton>
            ) : (
              <PrimaryButton
                type="submit"
                onClick={viewModel.handleSubmitCadastroPermissoes}
                startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
              >
                Salvar
              </PrimaryButton>
            )}
          </div>
        </div>
      </BottomBar>

      <ReportLogAcessoSistemaModal
        open={viewModel.openReportLogAcessoSistemaModal}
        loading={viewModel.loading}
        saving={viewModel.saving}
        ddlUsuarios={viewModel.ddlUsuarios}
        onClose={() => viewModel.handleOpenReportLogAcessoSistemaModal(false)}
        onSubmit={viewModel.handleLogAcessoSistemaReportSubmit}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />
    </>
  );
}